import FormAddressInput from "../../../../components/form/FormField/FormAddressInput";
import {
  AddressInput,
  AutoCompleteInput,
  CommentInput,
  DateInput,
  DropDownChoice,
  DropDownMultipleInput,
  DropDownOptionSetInput,
  FormFields,
  FormSection,
  MultilineInput,
  MultipleOptionSetInput,
  OptionSetInput,
  TextInput,
  TimeInput,
} from "../../../../types";
import { specialEventsGeneralDisplayNames } from "../../displayNames";
import { incidentOptionSetsChoices } from "../../optionSetChoices";

export type EditDemandSpecialEventsGeneralFields = {
  vdl_lieudelevenement: AddressInput;
  vdl_precisionsurlelieu: OptionSetInput;
  vdl_siautreprecisezlieu: TextInput;
  vdl_encasdintemperieslevenementest: MultipleOptionSetInput;
  vdl_siremisle: DateInput;
};


const editDemandSpecialEventsGeneralFields: EditDemandSpecialEventsGeneralFields =
  {
    vdl_lieudelevenement: {
      type: "address",
      error: "",
      value: null,
      required: true,
      fillLine: true,
      label: specialEventsGeneralDisplayNames.vdl_lieudelevenement,
    },
    vdl_precisionsurlelieu: {
      type: "options",
      error: "",
      value: null,
      required: true,
      fillLine: true,
      choices: incidentOptionSetsChoices.vdl_precisionsurlelieu,
      label: specialEventsGeneralDisplayNames.vdl_precisionsurlelieu,
    },
    vdl_siautreprecisezlieu: {
      type: "text",
      error: "",
      value: "",
      required: false,
      fillLine: true,
      disabledCondition: (fields: FormFields) =>
        fields.vdl_precisionsurlelieu.value !== 948300006, //Autre
      label: specialEventsGeneralDisplayNames.vdl_siautreprecisezlieu,
    },
    vdl_encasdintemperieslevenementest: {
      type: "multipleoptions",
      error: "",
      value: [],
      required: true,
      fillLine: true,
      choices: incidentOptionSetsChoices.vdl_encasdintemperieslevenementest,
      label:
        specialEventsGeneralDisplayNames.vdl_encasdintemperieslevenementest,
      onChangeEvent: (fields: FormFields) => {
        try {
          const fields2 = <EditDemandSpecialEventsGeneralFields>fields;
          if (
            !fields2.vdl_encasdintemperieslevenementest.value.includes(948300002) //Remis
          ) {
            return {
              vdl_siremisle: {
                ...fields2.vdl_siremisle,
                value: null,
              },
            };
          }
        } catch (error) {
          return undefined
        }
      },
    },
    vdl_siremisle: {
      type: "date",
      error: "",
      value: null,
      required: false,
      fillLine: true,
      disablePast: true,
      disabledCondition: (fields: FormFields) =>
        !(fields.vdl_encasdintemperieslevenementest.value as number[]).includes(
          948300002 //Remis
        ),
      label: specialEventsGeneralDisplayNames.vdl_siremisle,
    },
  };

const editDemandSpecialEventsGeneralCommonSection: FormSection<EditDemandSpecialEventsGeneralFields> =
  {
    fields: [
      "vdl_lieudelevenement",
      "vdl_precisionsurlelieu",
      "vdl_siautreprecisezlieu",
      "vdl_encasdintemperieslevenementest",
      "vdl_siremisle",
    ],
    title: "Informations",
  };

const editDemandSpecialEventsGeneralSections: FormSection<EditDemandSpecialEventsGeneralFields>[] =
  [editDemandSpecialEventsGeneralCommonSection];

export {
  editDemandSpecialEventsGeneralFields,
  editDemandSpecialEventsGeneralSections,
};
